import DomPurify from 'dompurify';

const SanatizedHtml = ({ dirtyHtml }) => {
  const cleanHtml = DomPurify.sanitize(dirtyHtml);
  return <span dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};

export default SanatizedHtml;
